import React from "react";
import { Segmented } from "antd";
import { useTranslation } from "react-i18next";
import {
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
  Legend,
} from "recharts";
import styles from "./intentInsights.module.scss";

export default function SentimentTrendCard({ series, periodDays, onPeriodChange }) {
  const { t } = useTranslation();
  const chartData = series || [];

  return (
    <article className={styles.insightCard}>
      <div className={styles.cardTitleRow}>
        <h3 className={styles.cardTitle}>
          {t("sonic_prospect.intent_insights.sentiment_title")}
        </h3>
        {onPeriodChange ? (
          <Segmented
            size="small"
            value={periodDays}
            onChange={onPeriodChange}
            options={[
              { label: t("sonic_prospect.intent_insights.period_7"), value: 7 },
              { label: t("sonic_prospect.intent_insights.period_30"), value: 30 },
            ]}
          />
        ) : null}
      </div>
      <div className={styles.chartWrap}>
        <ResponsiveContainer width="100%" height={220}>
          <LineChart data={chartData} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
            <XAxis dataKey="date" tick={{ fontSize: 11 }} stroke="rgba(255,255,255,0.35)" />
            <YAxis tick={{ fontSize: 11 }} stroke="rgba(255,255,255,0.35)" unit="%" />
            <Tooltip
              contentStyle={{
                background: "#1c193b",
                border: "1px solid rgba(124,58,237,0.3)",
                borderRadius: 8,
              }}
            />
            <Legend />
            <Line
              type="monotone"
              dataKey="positive"
              name={t("sonic_prospect.intent_insights.sentiment_positive")}
              stroke="#22c55e"
              strokeWidth={2}
              dot={false}
            />
            <Line
              type="monotone"
              dataKey="neutral"
              name={t("sonic_prospect.intent_insights.sentiment_neutral")}
              stroke="#94a3b8"
              strokeWidth={2}
              dot={false}
            />
            <Line
              type="monotone"
              dataKey="negative"
              name={t("sonic_prospect.intent_insights.sentiment_negative")}
              stroke="#ef4444"
              strokeWidth={2}
              dot={false}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </article>
  );
}
